import React, { useEffect, useState } from 'react';
import CourseRow from './CourseRow';
import './Courses.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div

            style={{ display: "none" }}
            onClick={onClick}
        />
    );
}
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={`${className}`}
            style={{ display: "none" }}
            onClick={onClick}
        />
    );
}


const Courses = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const { data: courses = [], isLoading, refetch } = useQuery({
        queryKey: ['cpcourses'],
        queryFn: () => fetch(`${process.env.REACT_APP_API_URL}/cpcourses`)
            .then(res => res.json())

    })



    return (
        <div className='bg-color w-full'>
            <div id='courses' className='px-5 max-w-6xl mx-auto  py-11 xl:px-0'>
            <div class=" mt-11 md:flex md:items-center md:justify-between ">
                <div>
                    <h1 class="text-3xl font-semibold text-gray-800 capitalize lg:text-4xl dark:text-white">
                        Featured Courses
                    </h1>
                    <p className='text-gray-500 pt-2'>Discover Your Perfect Program in Our Courses.</p>
                </div>

                <div class="mt-5 md:mt-0">
                <Link to='/allcourse'> <select className='px-3 pr-3 py-3 border w-full sm:w-auto'>
                        <option value="">All Courses</option>
                        <option value="">Another Option</option>
                        <option value="">Something else here</option>
                    </select></Link>
                </div>
            </div>
            <div>
                <Slider {...settings}>
                    {
                        courses?.map(course =>
                            <CourseRow key={course._id} course={course} />
                        )
                    }
                </Slider>
            </div>
        </div>
        </div>
    );
};

export default Courses;